import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPSelfSignificator } from './KPSelfSignificator';

export function KPSelfSignificatorChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[10]} className="m-0 p-0 ">
              <Row id="selfSignificatorsChart" className="m-0 p-0">
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    <KPSelfSignificator userData={userData}/>
                  </Col>
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    
                  </Col>
              </Row>
          </Collapse>
    }
  </>  
  );
}